/**
 * Construct Vuex 'cloud' module
 *
 * @param {*} services Services object for API access
 * @return {*}
 */
export default function(services) {
  /**
   * Retrieve all schools across all Cloud clusters
   * Returns Promise resolving to a single list of school objects
   *
   * @param {String} endpoint API endpoint to call to retrieve schools
   * @return {Promise<{}[]>}
   */
  function getSchools(endpoint) {
    return Promise.all(
      services.cloud.map((s) => s.get(endpoint))
    ).then((responses) =>
      responses.map((r) => r.data.data)
        .reduce((l, d) => l.concat(d), [])
    );
  }

  return {
    namespaced: true,
    state: {
      schools: [],
      requiresUpdate: true,
      allSchools: [],
      allSchoolsRequiresUpdate: true
    },
    mutations: {
      schools(state, schools) {
        state.schools = schools;
      },
      requiresUpdate(state, requiresUpdate) {
        state.requiresUpdate = requiresUpdate;
      },
      allSchools(state, schools) {
        state.allSchools = schools;
      },
      allSchoolsRequiresUpdate(state, requiresUpdate) {
        state.allSchoolsRequiresUpdate = requiresUpdate;
      }
    },
    actions: {
      initialize(context, forceUpdate) {
        if (context.state.requiresUpdate || forceUpdate) {
          context.commit('requiresUpdate', false);
          return getSchools('/accessibleSchools')
            .then((schools) => context.commit('schools', schools));
        }
      },
      initializeAllSchools(context, forceUpdate) {
        if (context.state.allSchoolsRequiresUpdate || forceUpdate) {
          context.commit('allSchoolsRequiresUpdate', false);
          if ('cloud' in context.rootState.auth.user.scopes) {
            return getSchools('/allSchools')
              .then((schools) => context.commit('allSchools', schools));
          } else {
            context.commit('allSchools', []);
          }
        }
      }
    }
  };
}
